import { Injectable } from "@angular/core";
import { Observable, Observer } from 'rxjs';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import ReconnectingWebSocket  from 'reconnecting-websocket';
import { CborDataDecorator } from ".././core/app.core.cbor";
import { ArrayAssociative } from "./../core/array.core.data";
const cbor = require('cbor-web');

const CHAT_URL = "wss://ws.neverume.com";
//const CHAT_URL = "ws://ws.neverume.localhost";
@Injectable({ providedIn: 'root'})
export class WebsocketService {
 private subject!: AnonymousSubject<MessageEvent>;
 public messages!: Subject<any>;
 constructor(private cdd: CborDataDecorator) {
	 if (!this.messages) {
     this.messages = <Subject<ArrayAssociative>>this.connect(CHAT_URL).pipe(
         map(
             (response: MessageEvent): ArrayAssociative => {
            	 console.log(response.data);
                 return response.data;
             }
         )
     );
     console.log("Messages connected: " + this.messages);
     }
 }

 public connect(url: any): AnonymousSubject<MessageEvent> {
     if (!this.subject) {
         this.subject = this.create(url);
         console.log("Successfully connected: " + url);
     }
     return this.subject;
 }
 public async sendws(message: ArrayAssociative) {
		let cborv = this.cdd.encode(message);
		cborv.then((d: any) => {
			this.messages.next(d);
		   });
		//this.sent.push(cborm);//cdd.encode(cborm);
	}
	
 private create(url: any): AnonymousSubject<MessageEvent> {
	 
     var ws = new ReconnectingWebSocket(url, undefined ,{
    	 maxReconnectionDelay: 1900,
    	 minReconnectionDelay: 1900,
    	 reconnectionDelayGrowFactor: 1.02,
    	 minUptime: 5000,
    	 connectionTimeout: 4000,
    	 maxRetries: Infinity,
    	 maxEnqueuedMessages: Infinity
     });//WebSocket(url);
     let observable = new Observable((obs: Observer<MessageEvent>) => {
         ws.onmessage = obs.next.bind(obs);
         ws.onerror = obs.error.bind(obs);
        // ws.onclose = obs.complete.bind(obs); //https://stackoverflow.com/questions/44060315/reconnecting-a-websocket-in-angular-and-rxjs
         return ws.close.bind(ws);
     });
     let observer = {
         error: () => console.error('Websockets service observer error'),
         complete:  () => console.log('Observer got a complete notification'),
         next: (data: any) => {
             if (ws.readyState === WebSocket.OPEN) {
                 ws.send(data);
             }
         }
     };

let cdd = new CborDataDecorator();
     ws.addEventListener('open', (event) => {
   	  console.log('WebSocket открыт', event);
   let	local = localStorage.getItem("local");
   let	session = sessionStorage.getItem("session");
		let space: ArrayAssociative = {
	docket: '',  //
	status: 'unsigned', //guest
	device: local, //tokendocket
	softhash: session, //tokendocket
	dockethash: '',// auth token 
};

console.log(space['device']);
console.log(space['status']);
console.log(space['device'] != '');
console.log(space['status'] == 'unsigned');

	let message: ArrayAssociative = {
		event: 'signverify',
		route: '/signverify',
		device: local, //tokendocket
			softhash: session,
		option: { 'type': 'registration' }
	}
	
		if (space['device'] != '') {
			
			
		} else {
	let message: ArrayAssociative = {
		event: 'signverify',
		route: '/signverify',
		docket: space['docket'],
		device: local, //tokendocket
		softhash: session,
		option: { 'type': 'verify' }
		
	}
	
	if (space['status'] == 'unsigned') {
		let message: ArrayAssociative = {
			event: 'signverify',
			device: local, //tokendocket
			softhash: session,
			route: '/signverify/unsigned',
			option: { 'type': 'registration' }
		}
	}
}

        console.log(message);
        console.log(space);
     let cborv = cdd.encode(message);
	  cborv.then((d: string) => {
		     ws.send(d);
		   });
   	  // Отправка сообщения при открытии соединения
   	 
   	});
     console.log(observer);
     return new AnonymousSubject<MessageEvent>(observer, observable);
 }
}

//https://stackoverflow.com/questions/26971026/handling-connection-loss-with-websockets  proxy_read_timeout – maximum time (between reads) to read proxied server response (default 60) proxy_send_timeout 